import React from 'react';

interface BundleWorkListHeadingProps {
  readonly children: React.ReactNode;
  readonly subtitle?: React.ReactNode;
}

/** Scan Label `.sl-prompt` type, with the return-screen red divider under the copy. */
function BundleWorkListHeading({ children, subtitle }: BundleWorkListHeadingProps): React.ReactElement {
  return (
    <div className="bundle-work-list-intro">
      <p className="bundle-work-list-heading">{children}</p>
      {subtitle ? <p className="bundle-work-list-subheading">{subtitle}</p> : null}
      <hr className="bundle-work-return-divider" />
    </div>
  );
}

export default BundleWorkListHeading;
